// Chakra imports
import { Flex } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Produit from "./components/Produit";
import { tablesTableData } from "variables/general";
// import productService from "../../../api/products/products";
import productService from "../../../api/products/products";
import categorieService from "../../../api/categories/categories";

function TablesProduct() {
  const [products, setProducts] = useState([]); // État pour stocker les produits
  const [categories, setCategories] = useState([]); // État pour stocker les produits
  const [loading, setLoading] = useState(true); // État pour gérer le chargement
  const [error, setError] = useState(null); // État pour gérer les erreurs

  useEffect(() => {
    // Fonction pour récupérer les produits
    const fetchProducts = async () => {
      try {
        setLoading(true); // Activer l'état de chargement
        const responseCat = await categorieService.getCategories();
        const response = await productService.getProducts();
        console.log(response)
        setProducts(response); // Stocker les données récupérées
        setCategories(responseCat)
      } catch (err) {
        console.error("Erreur lors de la récupération des produits :", err);
        setError(err.message || "Une erreur s'est produite.");
      } finally {
        setLoading(false); // Désactiver l'état de chargement
      }
    };

    fetchProducts(); // Appeler la fonction de récupération
  }, []); // Le tableau vide assure que l'effet s'exécute une seule fois au montage

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Produit
        title={"Produit"}
        captions={["Produit", "Catégorie", "Crée le", ""]}
        data={loading ? [] : products} // Afficher les données récupérées ou un tableau vide si en chargement
        categories={categories}
      />
      {/* {loading && <p>Chargement des produits...</p>} {/* Afficher un message de chargement */}
      {/* {error && <p style={{ color: "red" }}>Erreur : {error}</p>} Afficher les erreurs */}
    </Flex>
  );
}

export default TablesProduct;
